import { CreatePatientRequestDTO } from '../../dtos/CreatePatientRequestDTO';
import { User } from '../../entities/User';
import { api } from '../api';

export const createPatient = async ({
  patientData,
  personalData,
  type,
  institutionId,
}: CreatePatientRequestDTO): Promise<User> => {
  const { data } = await api.post('/patients', {
    patientData,
    personalData,
    type,
    // Omitido quando ausente, e não enviado como `undefined`: o `celebrate` da rota
    // fecha as chaves do corpo, e `institutionId: null` seria 400. Sem o campo, o back
    // deriva a instituição do escopo do token (tarefa 0.15).
    ...(institutionId ? { institutionId } : {}),
  });

  return data;
};
